/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { OfferingType } from "../Payment/OfferingType";
import { LicenseRenewal } from "../Payment/LicenseRenewal";

export class PaymentLinkDto {
    licenseId: string;
    organisationId: string;
    offeringType: OfferingType;
    licenseRenewal: LicenseRenewal;
    paymentId: string;
    url: string;
}
